import { render, staticRenderFns } from "./SectionWorks.vue?vue&type=template&id=7711f6f9&"
import script from "./SectionWorks.vue?vue&type=script&lang=js&"
export * from "./SectionWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports